export default {"src":"/_next/static/media/carOutline_24.42b69577.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};